import React from "react";
import { Button } from "@clarkinc/zest-design-system";
import { Tooltip } from "@clarkinc/zest-design-system/ui";
import { upperCaseFirst } from "@wss/utilities/strings";
import { Store } from "@wss/store";
import Icon from "~/common/Icons/Standard";
import { ChromeBarState, ViewSetting } from "./useChromeBarComponentStore";
interface Props {
  chromeBarStore: Store<ChromeBarState>;
}
const ToggleView = ({
  chromeBarStore
}: Props) => {
  const handleButtonClick = (view: ViewSetting) => {
    chromeBarStore.setState({
      view
    });
  };
  const baseClasses = "border-solid border box-border cursor-pointer inline-block text-center no-underline antialiased focus-visible:outline focus-visible:outline-offset-2 focus-visible:outline-2";
  const uiButtonClasses = "text-shadow-white-75 hover:bg-gray-50 border-gray-400 text-gray-800 focus-visible:outline-gray-800 active:shadow-inset-black-15 align-middle font-semibold";
  const renderButton = (id: string, testId: string, viewType: ViewSetting, classes: string, tooltipContent?: string) => {
    const activeView = chromeBarStore.useState(state => state.view);
    const button = <Button id={id} size="small" theme="headless" data-testid={testId} onClick={() => handleButtonClick(viewType)} className={`${baseClasses} ${classes} ${activeView === viewType ? "bg-gray-200 hover:bg-gray-400" : ""} ${uiButtonClasses}`} data-no-jquery aria-pressed={activeView === viewType} aria-label={`${viewType} view`}>
        <Icon name={viewType} width="16px" height="16px" className="block mx-auto align-middle" />
        <span className="text-xs text-gray-800 leading-3 ml-1 block lt:hidden">
          {upperCaseFirst(viewType)}
        </span>
      </Button>;
    return tooltipContent ? <Tooltip content={tooltipContent} key={`${viewType}-view-Tooltip`} theme="wss" data-sentry-element="Tooltip" data-sentry-component="renderButton" data-sentry-source-file="ToggleView.tsx">
        {button}
      </Tooltip> : button;
  };
  return <>
      <div className="inline-flex lt:hidden">
        {renderButton("grid-view-tooltip-button", "tablet-grid-view", "grid", "rounded-l mr-0 rounded-r-none py-1 px-2 flex items-center lt:block lt:h-6 lt:p-0 lt:w-6 focus-visible:[position:relative] focus-visible:z-10")}
        {renderButton("list-view-tooltip-button", "tablet-list-view", "list", "rounded-r ml-0 rounded-l-none border-l-0 py-1 px-2 flex items-center lt:block lt:h-6 lt:p-0 lt:w-6")}
      </div>
      <div className="hidden lt:inline-flex lt:pr-2">
        {renderButton("grid-view-tooltip-button", "browser-grid-view", "grid", "rounded-l mr-0 rounded-r-none py-1 px-2 flex items-center lt:block lt:h-6 lt:p-0 lt:w-6 focus-visible:[position:relative] focus-visible:z-10", "Grid View")}
        {renderButton("list-view-tooltip-button", "browser-list-view", "list", "rounded-r ml-0 rounded-l-none border-l-0 py-1 px-2 flex items-center lt:block lt:h-6 lt:p-0 lt:w-6", "List View")}
      </div>
    </>;
};
export default ToggleView;